function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M164.292 101.918L192.171 129.798L167.948 154.02L154.009 140.081L164.292 101.918Z",
  fill: "#EAEEF4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M172.062 67.641L171.708 67.9945L172.062 68.3481L172.415 67.9945L172.062 67.641ZM185.316 80.8949L184.962 80.5414L184.608 80.8949L184.962 81.2485L185.316 80.8949ZM196.741 92.3208L196.388 92.6743L196.741 93.0279L197.095 92.6743L196.741 92.3208ZM160.864 78.8383L161.218 79.1918L161.571 78.8383L161.218 78.4847L160.864 78.8383ZM152.638 87.0649L152.284 87.4184L152.638 87.772L152.991 87.4184L152.638 87.0649ZM149 99.5L149.488 99.6075L149.548 99.3359L149.349 99.1418L149 99.5ZM142.583 128.655L142.229 129.008L142.875 129.654L143.071 128.762L142.583 128.655ZM207.025 102.604L206.671 102.25L206.317 102.604L206.671 102.958L207.025 102.604ZM164.292 101.918L164.646 101.565L164.034 100.954L163.809 101.788L164.292 101.918ZM192.171 129.798L192.525 130.151L192.878 129.798L192.525 129.444L192.171 129.798ZM167.948 154.02L167.595 154.374L167.948 154.727L168.302 154.374L167.948 154.02ZM154.009 140.081L153.526 139.951L153.451 140.23L153.655 140.434L154.009 140.081ZM202.911 140.538L203.265 140.184L202.911 139.831L202.558 140.184L202.911 140.538ZM157.208 164.761L157.561 165.114L157.915 164.761L157.561 164.407L157.208 164.761ZM143.268 150.821L143.622 150.468L143.268 150.114L142.915 150.468L143.268 150.821ZM131.843 139.395L132.196 139.749L132.55 139.395L132.196 139.042L131.843 139.395ZM96.4225 103.975L96.776 103.622L96.4225 103.268L96.0689 103.622L96.4225 103.975ZM204.614 34.381L171.708 67.2874L172.415 67.9945L205.321 35.0881L204.614 34.381ZM172.415 67.2874L139.052 33.924L138.345 34.6311L171.708 67.9945L172.415 67.2874ZM217.868 47.635L184.962 80.5414L185.669 81.2485L218.575 48.3421L217.868 47.635ZM184.962 81.2485L196.388 92.6743L197.095 91.9672L185.669 80.5414L184.962 81.2485ZM197.095 92.6743L230.001 59.7679L229.294 59.0608L196.388 91.9672L197.095 92.6743ZM127.147 45.8284L160.511 79.1918L161.218 78.4847L127.854 45.1213L127.147 45.8284ZM160.511 78.4847L152.284 86.7113L152.991 87.4184L161.218 79.1918L160.511 78.4847ZM152.991 86.7113L119.628 53.3479L118.921 54.055L152.284 87.4184L152.991 86.7113ZM110.151 62.3582L148.651 99.8582L149.349 99.1418L110.849 61.6418L110.151 62.3582ZM148.512 99.3925L142.095 128.547L143.071 128.762L149.488 99.6075L148.512 99.3925ZM142.936 128.301L92.4342 77.7992L91.7271 78.5063L142.229 129.008L142.936 128.301ZM173.765 92.4458L224.724 143.405L225.431 142.698L174.472 91.7387L173.765 92.4458ZM239.577 69.3441L206.671 102.25L207.378 102.958L240.285 70.0512L239.577 69.3441ZM206.671 102.958L235.921 132.208L236.628 131.501L207.378 102.25L206.671 102.958ZM163.938 102.272L191.817 130.151L192.525 129.444L164.646 101.565L163.938 102.272ZM191.817 129.444L167.595 153.667L168.302 154.374L192.525 130.151L191.817 129.444ZM168.302 153.667L154.362 139.727L153.655 140.434L167.595 154.374L168.302 153.667ZM154.491 140.211L164.775 102.049L163.809 101.788L153.526 139.951L154.491 140.211ZM215.605 152.524L203.265 140.184L202.558 140.891L214.898 153.231L215.605 152.524ZM202.558 140.184L155.255 187.487L155.962 188.194L203.265 140.891L202.558 140.184ZM145.222 177.454L157.561 165.114L156.854 164.407L144.514 176.747L145.222 177.454ZM157.561 164.407L143.622 150.468L142.915 151.175L156.854 165.114L157.561 164.407ZM142.915 150.468L130.575 162.807L131.282 163.515L143.622 151.175L142.915 150.468ZM119.856 152.089L132.196 139.749L131.489 139.042L119.149 151.382L119.856 152.089ZM132.196 139.042L96.776 103.622L96.0689 104.329L131.489 139.749L132.196 139.042ZM96.0689 103.622L83.729 115.961L84.4361 116.669L96.776 104.329L96.0689 103.622Z",
  fill: "#BEC7D6"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 92,
  r: 40,
  fill: "#00BAFF",
  fillOpacity: 0.23
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 81.668,
  cy: 92.3047,
  r: 8,
  transform: "rotate(-90 81.668 92.3047)",
  fill: "#00BAFF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81.668,
  cy: 92.3047,
  r: 6.64308,
  transform: "rotate(-90 81.668 92.3047)",
  stroke: "white",
  strokeWidth: 2.71385
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M204 156C199.8 156 196 159.22 196 164.2C196 167.38 198.45 171.12 203.34 175.43C203.72 175.76 204.29 175.76 204.67 175.43C209.55 171.12 212 167.38 212 164.2C212 159.22 208.2 156 204 156ZM204 166C202.9 166 202 165.1 202 164C202 162.9 202.9 162 204 162C205.1 162 206 162.9 206 164C206 165.1 205.1 166 204 166Z",
  fill: "#FF6562"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd",
  x: 0.394038,
  y: 23.2431,
  width: 162.548,
  height: 165.262,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 10.8554,
  operator: "dilate",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 12.2123
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 31.2093
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.282353 0 0 0 0 0.309804 0 0 0 0 0.372549 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 4.07077,
  operator: "dilate",
  in: "SourceAlpha",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 32.5662
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 25.7816
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.623529 0 0 0 0 0.670588 0 0 0 0 0.733333 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 9.49847,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect3_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 14.9262
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.1769
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.745098 0 0 0 0 0.780392 0 0 0 0 0.839216 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow",
  result: "effect3_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow",
  result: "shape"
})));

function SvgMapPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 201,
    viewBox: "0 0 270 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = React.forwardRef(SvgMapPoint);
export default __webpack_public_path__ + "static/media/map_point.e545d42c.svg";
export { ForwardRef as ReactComponent };